import { HILForm } from '../../interfaces/scheduler_interfaces';
import { CourseSchedulerConstant } from '../../views/course_scheduler/constants/course_scheduler_constants';
import { SectionRegistrationAttributesQuery } from '../queries/section_registration_attributes_query';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

export type WaitForRegistraionAttributesToRenderCommand = () => ng.IPromise<IQuery>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'waitForRegistraionAttributesToRenderCommand',
    (
      defineCommand: IDefineCommand,
      $timeout: ng.ITimeoutService,
      ngSectionRegistrationAttributesQuery: SectionRegistrationAttributesQuery
    ) =>
      defineCommand('waitForRegistraionAttributesToRenderCommand', (deferred) => {
        const formUpdateRenderDelay = 300;
        const totalNoOfAttributes = _4.sumBy(
          _4.toArray(ngSectionRegistrationAttributesQuery.result),
          (section) => section.attributes.properties.length
        );
        const timeOutDelay = formUpdateRenderDelay * totalNoOfAttributes;
        $timeout(() => deferred.resolve(), timeOutDelay);
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/commands/wait_for_registration_attributes_to_render_command.ts